/**
 * Accordion
 *
 * @since   1.1.1
 * @package hbs
 */
(function($) {
    $(document).ready(function() {
        clipboard = new ClipboardJS('.copy-code');
        clipboard.on('success', function(e) {
            $(e.trigger).addClass("coppied").delay(1000).queue(function(next){
                $(e.trigger).removeClass("coppied");
                next();
            });
        });
    }); // document.ready
})(jQuery);
